export const ROLE_MODE_RECOMMENDED = "recommended";
export const ROLE_MODE_CUSTOM = "custom";

export const RECOMMENDED_ROLES = [
  {
    id: "manager",
    name: "Manager",
    description:
      "Broad operational access across enquiries, billing, tasks, checklists, and reports.",
    tagline: "Operations lead",
    accent: "#1E3A8A",
    template: {
      includeCategories: [
        "Enquiries",
        "Invoices",
        "Profile",
        "Appointments & FollowUps",
        "Tasks",
        "Checklists",
        "Digital Register",
        "FeedBack",
        "Event Photos",
        "Event Vendors",
        "Menu",
      ],
      excludeCategories: ["Roles & permission"],
    },
  },
  {
    id: "executive",
    name: "Executive",
    description:
      "Handles enquiries, appointments, and customer follow-ups with limited administrative access.",
    tagline: "Sales & coordination",
    accent: "#34657F",
    template: {
      includeCategories: [
        "Enquiries",
        "Appointments & FollowUps",
        "Profile",
        "Invoices",
        "Menu",
      ],
      excludeNames: ["Delete"],
    },
  },
  {
    id: "receptionist",
    name: "Receptionist",
    description:
      "Front-desk access for enquiries, appointments, visitor log, and basic profile viewing.",
    tagline: "Front desk",
    accent: "#58A7AF",
    template: {
      includeCategories: ["Enquiries", "Appointments & FollowUps", "Digital Register", "Profile", "Menu"],
      excludeNames: ["Delete", "Update Role", "Add Permission"],
    },
  },
  {
    id: "security-guard",
    name: "Security Guard",
    description:
      "Focused access for visitor management and gate operations with minimal system visibility.",
    tagline: "Visitor & gate access",
    accent: "#84329B",
    template: {
      includeCategories: ["Digital Register", "Menu"],
      includeNames: ["View", "Home", "Register", "Visitor"],
      excludeNames: ["Delete"],
    },
  },
];

export const RECOMMENDED_ROLE_NAMES = RECOMMENDED_ROLES.map((role) => role.name);

export const findRecommendedRoleByName = (name) => {
  const normalized = String(name || "").trim().toLowerCase();
  return (
    RECOMMENDED_ROLES.find((role) => role.name.toLowerCase() === normalized) || null
  );
};

export const getRecommendedRoleByName = findRecommendedRoleByName;

export const isRecommendedRoleName = (name) => Boolean(findRecommendedRoleByName(name));

const matchesNamePattern = (permissionName, patterns = []) => {
  const normalized = String(permissionName || "").toLowerCase();
  return patterns.some((pattern) => normalized.includes(String(pattern).toLowerCase()));
};

export const resolveTemplatePermissionIds = (permissionsList = [], template = {}) => {
  const {
    includeCategories = [],
    excludeCategories = [],
    includeNames = [],
    excludeNames = [],
  } = template;

  return permissionsList
    .filter((perm) => {
      const category = perm.category || "Uncategorized";
      const name = perm.name || "";

      if (excludeCategories.includes(category)) return false;
      if (matchesNamePattern(name, excludeNames)) return false;

      if (includeCategories.includes(category)) return true;
      if (includeNames.length > 0 && matchesNamePattern(name, includeNames)) return true;

      return false;
    })
    .map((perm) => perm.id);
};

export const countTemplatePermissions = (permissionsList = [], template = {}) =>
  resolveTemplatePermissionIds(permissionsList, template).length;
